import React from "react";

export default (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 4C8 3.44772 8.44772 3 9 3H15C15.5523 3 16 3.44772 16 4H8ZM6 4C6 2.34315 7.34315 1 9 1H15C16.6569 1 18 2.34315 18 4L22 4C22.5523 4 23 4.44772 23 5C23 5.55229 22.5523 6 22 6H21.0001C21.0001 6.04096 20.9975 6.08236 20.9923 6.12403L18.9923 22.124C18.9297 22.6245 18.5043 23 18 23H6C5.49568 23 5.07028 22.6245 5.00772 22.124L3.00772 6.12403C3.00251 6.08236 2.99995 6.04095 2.9999 6H2C1.44772 6 1 5.55228 1 5C1 4.44772 1.44772 4 2 4H6ZM5.00778 6L18.9922 6L17.1172 21H6.88278L5.00778 6ZM10 9C10.5523 9 11 9.44771 11 10L11 16C11 16.5523 10.5523 17 10 17C9.44771 17 9 16.5523 9 16L9 10C9 9.44771 9.44772 9 10 9ZM15 10C15 9.44771 14.5523 9 14 9C13.4477 9 13 9.44771 13 10L13 16C13 16.5523 13.4477 17 14 17C14.5523 17 15 16.5523 15 16L15 10Z"
      fill="white"
    />
  </svg>
);
